import { render, staticRenderFns } from "./StreamContainerPC.vue?vue&type=template&id=fbc73dc2&scoped=true"
import script from "./StreamContainerPC.vue?vue&type=script&setup=true&lang=ts"
export * from "./StreamContainerPC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StreamContainerPC.vue?vue&type=style&index=0&id=fbc73dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc73dc2",
  null
  
)

export default component.exports